import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ngx-channel-skeletons',
  templateUrl: './channel-skeletons.component.html',
  styleUrls: ['./channel-skeletons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChannelSkeletonsComponent {
  @Input() chatSize: string;
}
